export default __webpack_public_path__ + "static/media/logo_letter_white.c9c79671.svg";